import React, { Component } from 'react';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { formatMoney } from '../../../util/currency';
import { ensureListing } from '../../../util/data';
import { isPriceVariationsEnabled } from '../../../util/configHelpers';

import css from './SearchMapPriceLabel.module.css';
const filterClasses = {
  signedUp: css.signedUp, // No shadow
  boothConfigured: css.boothConfigured, // Black shadow
  onboarded: css.onboarded, // Green shadow
  activeEngaged: css.activeEngaged, // Purple shadow
  tradeShow: css.tradeShow, // Blue shadow
};

/**
 * SearchMapPriceLabel component
 * TODO: change to functional component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that extends the default class for the root element
 * @param {propTypes.listing} props.listing - The listing
 * @param {Function} props.onListingClicked - The function to handle the listing click
 * @param {Object} props.config - The configuration
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
class SearchMapPriceLabel extends Component {
  shouldComponentUpdate(nextProps) {
    const currentListing = ensureListing(this.props.listing);
    const nextListing = ensureListing(nextProps.listing);
    const isSameListing = currentListing.id.uuid === nextListing.id.uuid;
    const hasSamePrice = currentListing.attributes.price === nextListing.attributes.price;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;

    return !(isSameListing && hasSamePrice && hasSameActiveStatus && hasSameRefreshToken);
  }

  render() {
    const {
      className,
      rootClassName,
      listing,
      onListingClicked,
      intl,
      isActive,
      config,
    } = this.props;
    const currentListing = ensureListing(listing);
    const { attributes } = currentListing.author || {};
    const { tag, rfpBids = 0, ratings = 0 } = attributes.profile.publicData || {};
    // const { price, publicData } = currentListing.attributes || {};
    const { price, publicData, title } = currentListing.attributes || {};
    const {
      boothType,
      stripeOnBoard,
    } = publicData || {};

    // Create formatted price if currency is known or alternatively show just the unknown currency.
    const formattedPrice =
      price && price.currency === config.currency
        ? formatMoney(intl, price)
        : price?.currency
        ? price.currency
        : null;

    const priceValue = formattedPrice
      ? intl.formatMessage({ id: 'SearchMapPriceLabel.price' }, { priceValue: formattedPrice })
      : null;

    const validListingTypes = config.listing.listingTypes;
    const foundListingTypeConfig = validListingTypes.find(
      conf => conf.listingType === publicData?.listingType
    );
    const isPriceVariationsInUse = isPriceVariationsEnabled(publicData, foundListingTypeConfig);
    const hasMultiplePriceVariants =
      isPriceVariationsInUse && publicData?.priceVariants?.length > 1;

    const priceMessage = hasMultiplePriceVariants
      ? intl.formatMessage({ id: 'SearchMapInfoCard.priceStartingFrom' }, { priceValue })
      : intl.formatMessage({ id: 'SearchMapInfoCard.price' }, { priceValue });

    const classes = classNames(rootClassName || css.root, className);

    let appliedClass = '';
    if (tag == 'Trade Show') {
      appliedClass = filterClasses.tradeShow; // Filter 5
    } else if ((rfpBids > 0) || (ratings > 0)) {
      appliedClass = filterClasses.activeEngaged; // Filter 4
    } else if (stripeOnBoard) {
      appliedClass = filterClasses.onboarded; // Filter 3
    } else if (boothType && boothType.length) {
      appliedClass = filterClasses.boothConfigured; // Filter 2
    } else {
      appliedClass = filterClasses.signedUp; // Filter 1
    }

    const priceLabelClasses = classNames(css.priceLabel, appliedClass, {
      [css.mapLabelActive]: isActive,
      [css.noPriceSetLabel]: !formattedPrice,
    });
    const caretClasses = classNames(css.caret, { [css.caretActive]: isActive });

    const ariaLabel = priceValue
      ? priceMessage
      : intl.formatMessage({ id: 'SearchMapPriceLabel.screenreader.mapMarkerWithoutPrice' });

    return (
      <button
        className={classes}
        onClick={() => onListingClicked(currentListing)}
        aria-label={ariaLabel}
      >
        <div className={css.caretShadow} />
        <div className={priceLabelClasses}>
          <span className={css.price}>
            {/* {formattedPrice} */}
            </span>
          </div>
        <div className={caretClasses} />
      </button>
    );
  }
}

export default injectIntl(SearchMapPriceLabel);
